import * as React from 'react'

import type User from 'modules/core/store/models/User'

import type QuestionGroupActor from 'modules/reviews/store/models/QuestionGroupActor'

import AnonymousUser from '../AnonymousUser'
import EmployeeLabel from '../CommonEmployeeLabel'
import MeAnonymousLabel from '../MeAnonymousLabel'

interface Props {
  user: User | QuestionGroupActor | null | undefined
  isAnonymous?: boolean
}

export default function EmployeeLabelWithFallback({ user, isAnonymous }: Props) {
  if (user && isAnonymous) return <MeAnonymousLabel user={user} /> // currentUserAnonymous
  if (user) return <EmployeeLabel user={user} />
  return <AnonymousUser />
}
